import React, { useRef, useState } from "react";
import DownloadExcel from "../../Extra/DownloadExcel";
import { columns, headers } from "./CIHelper";
import { diffInDays, secondsToHHMM } from "../../Utilitie";
import CIEverBest from "./CIEverBest/CIEverBest";
import { TbCircleDotFilled } from "react-icons/tb";
import CIPunctualityData from "./CIPunctuality/CIPunctualityData";
import IREPercentage from "./CIEverBest/IREPercentage";
import SevenALoadingMaster from "../7ALoading/SevenALoadingMaster";
import EverBest7a from "./7aEverBest/EverBest7a";
import DownloadAsImage from "../../Extra/DownloadAsImage";
import InterChangeEverBest from "./CIEverBest/InterChangeEverBest";
import TYLoadingData from "../Best data/TenYearsData.jsx/TYLoadingData";
import LDMTEverBest from "./7aEverBest/LDMTEverBest";

const avgOut = [
  "TAKEN OVER [TRAINS]",
  "HANDED OVER [TRAINS]",
  "TOTAL TRANSACTION [TRAINS]",
  "TAKEN OVER [WAGONS]",
  "HANDED OVER [WAGONS]",
  "DIFFERENCE [WAGONS]",
  "TOTAL TRANSACTION [WAGONS]",
];

const CITable = ({ rows, date }) => {
  const tableRef = useRef();
  const [active, setActive] = useState("BestEver");

  const [head, setHead] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [selectedHead, setSelectedHead] = useState(null);

  const handleClose = () => {
    setShowModal(false);
    setActive("BestEver");
  };

  const handleRowClick = (key) => {
    setHead(key);
    setSelectedHead(key);
    setShowModal(true);
  };
  const getValue = (data, colKey, rowKey) => {
    const dateObj = new Date(data?.current_yr_date.end);
    const days = dateObj.getDate();

    const fyDays =
      diffInDays(data?.current_yr_date.end, data?.current_yr_date.start) + 1;

    const rowData = data?.[colKey]?.[0];
    if (!rowData) return 0;
    //////////////////////////////////
    if (rowKey === "percentage1") {
      return data?.[colKey]?.[1]?.percentage ?? 0;
    }
    if (rowKey === "percentage2") {
      return data?.[colKey]?.[2]?.percentage ?? 0;
    }
    //////////////////////////////////////////

    if (rowKey === "Total_Transaction") {
      return Number(rowData.rcpts || 0) + Number(rowData.dspts || 0);
    }

    if (rowKey === "Total_Transaction_Trains") {
      return Number(rowData.TRAIN_TO || 0) + Number(rowData.TRAIN_HO || 0);
    }

    const loadingKeys = [
      "arrival_to_placement_loading",
      "placement_to_release_loading",
      "release_to_departure_loading",
    ];

    const unloadingKeys = [
      "arrival_to_placement_unloading",
      "placement_to_release_unloading",
      "release_to_departure_unloading",
    ];

    const isMonth =
      colKey === "current_month_data" || colKey === "last_year_month_data";

    const isFY =
      colKey === "current_fy_data_till_date" || colKey === "last_fy_data";

    if (rowKey === "Total_Detention_Loading") {
      let total =
        Number(rowData.arrival_to_placement_loading || 0) +
        Number(rowData.placement_to_release_loading || 0) +
        Number(rowData.release_to_departure_loading || 0);

      if (isMonth) total /= days;
      if (isFY) total /= fyDays;

      return secondsToHHMM(total) || "00:00";
    }

    if (rowKey === "Total_Detention_Unloading") {
      let total =
        Number(rowData.arrival_to_placement_unloading || 0) +
        Number(rowData.placement_to_release_unloading || 0) +
        Number(rowData.release_to_departure_unloading || 0);

      if (isMonth) total /= days;
      if (isFY) total /= fyDays;

      return secondsToHHMM(total) || "00:00";
    }

    if ([...loadingKeys, ...unloadingKeys].includes(rowKey)) {
      let value = Number(rowData[rowKey] || 0);

      if (isMonth) value /= days;

      if (isFY) value /= fyDays;

      return secondsToHHMM(value) || "00:00";
    }

    return Number(rowData[rowKey] || 0).toFixed(2);
  };
  const getDiff = (v1, v2) =>
    !v1 || !v2 || !isFinite(v1) || !isFinite(v2)
      ? "-"
      : (((v1 - v2) / v2) * 100).toFixed(2) + "%";
  const getNumericValue = (data, colKey, rowKey) => {
    const rowData = data?.[colKey]?.[0];
    if (!rowData) return 0;

    return Number(rowData[rowKey] || 0);
  };
  return (
    <div>
      {/* <DownloadAsImage /> */}

      <div
        className="table-responsive pt-0"
        style={{ fontSize: "12px", maxWidth: "1050px" }}
      >
        <table className="table glassTable" ref={tableRef}>
          <thead className="sticky-top">
            <tr>
              <th rowSpan={2}></th>
              <th
                rowSpan={2}
                style={{
                  width: "160px",
                  wordWrap: "break-word",
                  whiteSpace: "normal",
                }}
              >
                HEADS
              </th>
              {headers.map((head, i) => (
                <th
                  key={i}
                  colSpan={3}
                  style={{
                    width: "20px",
                    wordWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {head.toUpperCase()}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row) =>
              row.key === "Head" ? (
                <tr key={row.id} className="table-secondary">
                  <td>{row.id}</td>
                  <td colSpan={10}>{row.label}</td>
                </tr>
              ) : row.key === "Head1" ? (
                <tr key={row.id} className="table-secondary">
                  <td>{row.id}</td>
                  <td colSpan={9}>{row.label}</td>

                  <td>
                    <button onClick={() => handleRowClick(row.key)}>
                      {" "}
                      view
                    </button>
                  </td>
                </tr>
              ) : (
                <tr
                  key={row.id}
                  className={
                    row.key === "total" ||
                    row.key === "yday" ||
                    row.key === "today" ||
                    row.key === "WTR" ||
                    row.key === "Total_Transaction_Trains" ||
                    row.key === "percentage" ||
                    row.key === "percentage1" ||
                    row.key === "percentage2"
                      ? "table-success fw-bolder"
                      : null
                  }
                  onClick={() => handleRowClick(row.key)}
                  style={{ cursor: "pointer" }}
                >
                  <td
                    style={{
                      width: "10px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    <TbCircleDotFilled />
                  </td>
                  <td
                    style={{
                      width: "160px",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {row.label}
                  </td>

                  {columns.map((col) => (
                    <td
                      key={col.key}
                      style={{
                        width: "20px",
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                      className={
                        col.label === "Variation" ? "table-danger" : null
                      }
                    >
                      {avgOut.includes(row.label) &&
                      (col.key === "current_month_data" ||
                        col.key === "last_year_month_data")
                        ? (
                            getValue(row.source, col.key, row.key) /
                            Number(date.slice(8, 10))
                          ).toFixed(2)
                        : col.key === "date_variation"
                          ? getDiff(
                              getNumericValue(
                                row.source,
                                "current_date_data",
                                row.key,
                              ),
                              getNumericValue(
                                row.source,
                                "last_yr_date_data",
                                row.key,
                              ),
                            )
                          : col.key === "month_variation"
                            ? getDiff(
                                getNumericValue(
                                  row.source,
                                  "current_month_data",
                                  row.key,
                                ),
                                getNumericValue(
                                  row.source,
                                  "last_year_month_data",
                                  row.key,
                                ),
                              )
                            : col.key === "fy_variation"
                              ? getDiff(
                                  getNumericValue(
                                    row.source,
                                    "current_fy_data_till_date",
                                    row.key,
                                  ),
                                  getNumericValue(
                                    row.source,
                                    "last_fy_data",
                                    row.key,
                                  ),
                                )
                              : getValue(row.source, col.key, row.key)}
                    </td>
                  ))}
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>

      <div className="m-1 no-print">
        <DownloadExcel
          tableRef={tableRef}
          fileName={`ComparativeInterchange`}
        />
      </div>

      {showModal && (
        <>
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Details View</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  ></button>
                </div>
                <div className="row ">
                  <div className="d-flex justify-content-center m-2">
                    <button
                      onClick={() => {
                        setActive("BestEver");
                      }}
                      className={`btn btn-sm btn-outline-dark me-1 ${
                        active === "BestEver" && "active"
                      }`}
                    >
                      Best Ever
                    </button>
                    <button
                      onClick={() => {
                        setActive("MonthWise");
                      }}
                      className={`btn btn btn-outline-dark ms-1 ${
                        active === "MonthWise" && "active"
                      }`}
                    >
                      Month Wise
                    </button>
                    <hr />
                  </div>
                </div>

                {active === "BestEver" && head === "total" && (
                  <div className="modal-body   ">
                    {" "}
                    <div
                      className="newUiBody"
                      style={{ background: "rgba(255, 255, 255, 0.5)" }}
                    >
                      <LDMTEverBest
                        defCode={"LDG_MT"}
                        title={"loading (in MT)"}
                      />
                    </div>{" "}
                  </div>
                )}
                {/* {active === "BestEver" && (
                  <div className="modal-body   ">
                    <InterChangeEverBest
                      selectedHead={selectedHead}
                      date={date}
                    />
                  </div>
                )} */}
                {active === "BestEver" && head === "Head1" && (
                  <div className="modal-body   ">
                    <EverBest7a />
                  </div>
                )}

                {((active === "BestEver" && head === "percentage") ||
                  (active === "BestEver" && head === "percentage1") ||
                  (active === "BestEver" && head === "percentage2")) && (
                  <div className="modal-body   ">
                    <IREPercentage selectedHead={selectedHead} date={date} />
                  </div>
                )}

                {/* ///////////////////// */}
                {active === "BestEver" && (
                  <div className="modal-body   ">
                    <CIEverBest selectedHead={selectedHead} date={date} />
                  </div>
                )}

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={handleClose}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Backdrop (WITH fade) */}
          <div className="modal-backdrop fade show" onClick={handleClose}></div>
        </>
      )}
      {/* <CIPunctualityData date={date} /> */}
    </div>
  );
};

export default CITable;
